export default __webpack_public_path__ + "3a32b06aadc2c52f588e5488d3c36b3f.png";